/**
* CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.cta' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: '.cta .container',
            start: 'top 75%',
            end: 'bottom top',
            scrub: 0,
            onEnter: ( x, y, z ) => {
              $( '.cta__lines-one, .cta__lines-two, .cta__lines-three' ).addClass( 'is-loaded' );
            },
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cta', COMPONENT );
} )( app );
